/**
 *
 * LiveModeCourseCpnt
 *
 */

import { mapState, mapGetters, mapActions } from 'vuex';

import { ClassRestrictionMixin } from '@/mixins/ClassRestriction';

import LiveModeCourse from '@/scripts/LiveMode/LiveModeCourse';

export default {
  name: 'LiveModeCourseCpnt',

  mixins: [LiveModeCourse, ClassRestrictionMixin],

  data() {
    return {

    };
  },

  computed: {
    ...mapState('MainModeCourse', {
      MainModeCourse_ms_isRequest: 'isRequest',
    }),

    ...mapGetters({
      MainModeCourse: 'MainModeCourse/Course',
    }),

    ...mapGetters({
      LiveModeCourse_mg_isRequest: 'LiveModeCourse/isRequest',
    }),

    CourseId: function () {
      return this.$route.params.courseId;
    },

    ///
    c_courseId() {
      return Number(this.CourseId);
    },

    c_isCpntRequest: function () {
      return !this.MainModeCourse_ms_isRequest && this.LiveModeCourse_mg_isRequest;
    },

    ///
    c_restrictStudent() {
      return this.MainModeCourse.restrictStudent;
    },
  },

  methods: {
    //  ...mapActions('MainModeCourse', {
    //    ma_getCourseTaskStatus: 'getCourseTaskStatus',
    //  }),

    // //  getCourseTaskStatus() {
    // //    this.ma_getCourseTaskStatus({ courseId: this.CourseId });
    // //  },

    //  _PureModeCourseCpntCreated() {
    //    this.getCourseTaskStatus();
    //  },

    ///
    setPromiseGetClassRestriction() {
      this.promiseClassRestrictionCoursePageInfo = window.promiseGetCourse;
    },
  },
};
